interface DocumentViewerProps {
  fileUrl?: string;
}

export const DocumentViewer = ({ fileUrl }: DocumentViewerProps) => {
  if (!fileUrl) {
    return null;
  }

  return (
    <div className="w-full flex-1 min-h-0">
      <embed
        src={fileUrl}
        type="application/pdf"
        className="w-full h-full"
        title="document-viewer"
        style={{ minHeight: "60vh" }}
      />
    </div>
  );
};
